<template>
    <div class="autocomplete-wrapper">
        <input @focus="show_dropdown = true" :placeholder="placeholder" @blur="blurAutocomplete" v-model="ss_value" class="form-control"  />
        <button v-if="clear" class="button btn autocomplete-clear btn-secondary" @click="clearAutocomplete">Wyczyść</button>
        <div class="dropdown-menu"
             :class="{active: show_dropdown}"
             v-if="filteredDataObj.length > 0">
            <div class="dropdown-content">
               <a   v-for="(option, index) in filteredDataObj"
                    v-if="index < 50"
                    :key="option.id"
                    @click.prevent="optionPickedHandler(option)"
                    class="dropdown-single">
                    <strong v-html="highlightWord(option.name)"></strong>&nbsp;<strong v-html="highlightWord(option.surname)"></strong><br />
                    <span v-html="highlightWord(option.email)"></span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "SsAutocomplete",
        props: {
            label: {
                type: String,
                default: ''
            },
            placeholder: {
              type: String,
              default: ''
            },
            clear: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            'type': {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                default: ()=> []
            }
        },
        data() {
            return {
                show_dropdown: false,
                ss_value: '',
                uid: null
            }
        },
        mounted () {
            this.ss_value = this.value;
            this.uid = this._uid
        },
        computed: {
            hasValue(){
                return this.ss_value && this.ss_value.length > 0;
            },
            filteredDataObj() {
                return this.options.filter((option) => {
                    let isCorrect = this.filterContent(
                        option.name + ' ' +
                        option.surname + ' ' + option.email);
                    return isCorrect;
                })
            }
        },
        methods: {
            filterContent(content){
                if(this.ss_value.length > 0){
                    let res = this.ss_value.split(" ");
                    for(let word of res){
                        if(!this.filterWord(content, word)){
                            return false;
                        }
                    }
                    return true;
                }
            },
            filterWord(content, word){
                return content ? content
                    .toString()
                    .toLowerCase()
                    .indexOf(word.toLowerCase()) >= 0 : '';
            },
            blurAutocomplete(){
                if(!this.ss_value){
                    this.$emit('optionSelected', '');
                }
                setTimeout(()=>{this.show_dropdown = false}, 150);
            },
            clearAutocomplete(){
                this.ss_value = '';
                this.$emit('optionSelected', '');
                setTimeout(()=>{this.show_dropdown = false}, 150);
            },
            highlightWord(item){
                item = item ? item.toString() : '';
                let strings = this.ss_value.split(' ');
                let t = item;
                let re;
                for(let string of strings){
                    if(string !== '' && string !== 'i'){
                        re = new RegExp(string, "gi") ;
                        t = t.replace(re, match => {
                            return  "<i>" + match + "</i>";
                        });
                    }
                }
                return t;
            },
            optionPickedHandler(option){
                this.show_dropdown = false;
                this.ss_value = option.name + (option.surname ? ' ' + option.surname : '');
                this.$emit('optionSelected', option.id);
            },
        },
        watch: {
            'value'(to){
                if(!to){
                    this.ss_value= to;
                }
                this.$forceUpdate();
            }
        }
    }
</script>
<style>
    .dropdown-content i{
        color: var(--blue);
    }
</style>
<style lang="scss" scoped>

    .dropdown-single i{
        font-style: normal;
        font-weight:bold;
    }
    .dropdown-single{
        display: block;
        width: 100%;
        padding: 0.25rem 1.5rem;
        clear: both;
        font-weight: 400;
        color: #151b1e;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
        border-bottom: 1px #ccc solid;
        cursor: pointer;

        i{
            color: #007bff;
        }

        &:last-child{
            border-bottom: 0;
        }
        &:hover{
            background-color: #eaeaea;
        }
    }
    .dropdown-menu{
        right: 0;
        position: absolute;
        top: 35px;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 10rem;
        padding: 0 0;
        margin: 0;
        font-size: 0.875rem;
        color: #151b1e;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #c2cfd6;
        max-height: 22em;
        overflow: auto;
        i{
            color: #007bff;
        }
    }
    .dropdown-menu.active{
        display: block;
    }
    .autocomplete-wrapper{
        position: relative;
        display: flex;
        flex: 1;
    }
</style>
